import { Box, Typography, Container } from '@mui/material';
import { LocationOff } from '@mui/icons-material';
import { motion } from 'framer-motion';
import { CardSurface } from '../../ui/CardSurface';

export function ForaDaAreaScreen() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        px: 2,
      }}
    >
      <Container maxWidth="sm">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          <CardSurface sx={{ p: 4, textAlign: 'center' }}>
            <motion.div
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.1, type: 'spring', stiffness: 200 }}
            >
              <LocationOff
                sx={{
                  fontSize: 80,
                  color: 'warning.main',
                  mb: 3,
                }}
              />
            </motion.div>

            <Typography
              variant="h4"
              component="h1"
              fontWeight={700}
              gutterBottom
              sx={{ mb: 2 }}
            >
              Fora da Área de Atuação
            </Typography>

            <Typography
              variant="body1"
              color="text.secondary"
              sx={{ mb: 2, lineHeight: 1.6 }}
            >
              Você está fora do raio de 300 metros de qualquer empresa cadastrada.
            </Typography>

            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ lineHeight: 1.6 }}
            >
              Por favor, aproxime-se de uma empresa para realizar aferições.
            </Typography>
          </CardSurface>
        </motion.div>
      </Container>
    </Box>
  );
}
